import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseServiceV2 } from '@servicesv2';

export interface PesagemVolumeViewModel {
  id: number;
  embalagem: number;
  pesoEmbalagem?: number;
  pesoVolume?: number;
  nomeEmbalagem?: string;
}

export interface SalvarPesagemVolumesViewModel {
  pedidoId: number;
  volume: PesagemVolumeViewModel;
}

@Injectable({
  providedIn: 'root'
})
export class PesagemVolumesServiceV2 extends BaseServiceV2 {

  constructor(http: HttpClient) {
    super('Pedidos', http);
  }

  getVolumes(pedidoId: number) {
    return this.getAsPromise<PesagemVolumeViewModel[]>(`GetPedidosEmbalagensDespacho/${pedidoId}`);
  }

  salvarVolumes(model: SalvarPesagemVolumesViewModel) {
    return this.postAsPromise<SalvarPesagemVolumesViewModel, void>(model, 'SalvarPedidosEmbalagensDespacho');
  }

  excluirVolume(volumeId: number) {
    return this.deleteAsPromise<any, void>(`ExcluirPedidosEmbalagensDespacho/${volumeId}`);
  }
}